import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react"
import { NavBarExternal } from "./NavBarExternal"
import { IAuthenticationReducer } from "types/autentication"
import { ROUTES_NAMES } from 'constants/name.routes'

interface HeaderToShowProps {
    authenticationSelector: IAuthenticationReducer
    NavBarAuthenticated: () => JSX.Element
    sessionCypressAuthenticated: string
    pathname: string
}

export const HeaderToShow = ({ pathname, authenticationSelector, NavBarAuthenticated, sessionCypressAuthenticated }: HeaderToShowProps) => {    
    const ignorePathName = pathname !== '/' && !pathname.startsWith(ROUTES_NAMES.notifications)
                                            && !pathname.startsWith(ROUTES_NAMES.reports)
                                            && !pathname.startsWith(ROUTES_NAMES.exportReport)
                                            && !pathname.startsWith(ROUTES_NAMES.accessSystem)
                                            && !pathname.startsWith(ROUTES_NAMES.reports)
                                            && !pathname.startsWith(ROUTES_NAMES.notifySent)
                                            && !pathname.startsWith(ROUTES_NAMES.notifySentPatient)
                                            && !pathname.startsWith(ROUTES_NAMES.configurationsRoutes.configurations)
                                            && !pathname.startsWith(ROUTES_NAMES.documentation)
                                            && !pathname.startsWith(ROUTES_NAMES.notifyEventPatient)
    return (
        <>
            <AuthenticatedTemplate>
                {!authenticationSelector.azureAccessTokenExpired ? (
                    ((!authenticationSelector.jwtAccessTokenExpired)&&<NavBarAuthenticated />)
                ) : (
                    ignorePathName && (<NavBarExternal pathname={pathname} />)
                )}
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                {/** Usado para contornar temporariamente os cookies do Azure que não são salvos pelo Cypress */}
                {sessionCypressAuthenticated === 'true' ? (
                    <NavBarAuthenticated />
                ) : (
                    ignorePathName && (<NavBarExternal pathname={pathname} />)
                )}
            </UnauthenticatedTemplate>
        </>
    )
}